import React, { useEffect, useState } from "react"
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
//import "../../utils/font-awesome"

const Icon = ({ icon, size, className }) => {
  const [iconName, setIconName] = useState("")
  const [iconType, setIconType] = useState("")

  useEffect(() => {
    setIconName(icon.icon.replace("fa-", ""))
    setIconType(icon.type)
  }, [icon])

  return (
    <>
      {iconName !== "" ? (
        <span data-info="TODO: implement <Icon> component in your project" data-props-iconName={iconName} data-props-iconType={iconType}></span>
      ) : null}
    </>
  )
}

export default Icon
